import * as React from "react";

export class SectionHeader extends React.Component<{}, {}> {
  render() {
    return (
        <div className="sectionHeader" >{this.props.children}</div>
    );
  }
}
